import {fromJS, List, Map} from 'immutable';
import * as actionTypes from '../actions/types';

const initialState = new Map({
  id: 0,
  email: '',
  roles: new List(),
  passwordChangeRequired: false,
  authenticated: false,
  hasProjectTeamologySchool: false,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.LOAD_IDENTITY_FULFILLED:
    case actionTypes.LOGIN_FULFILLED:
      return state.withMutations(map =>
        map.merge(fromJS(action.payload.data))
          .set('authenticated', true));

    case actionTypes.LOAD_IDENTITY_REJECTED:
    case actionTypes.LOGOUT_PENDING:
      return initialState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/features/authentication/reducers/currentUser.js